import { useScrollToTop } from './use-scroll-to-top';
import { useWarnOnLeave } from './use-warn-on-leave';

export * from './use-scroll-to-top';

export const Hooks = {
  useScrollToTop,
  useWarnOnLeave,
};
